import type { BillingEntityAPI } from '@omnipresentgroup/types';

export const DEFAULT_BILLING_ENTITY: BillingEntityAPI = {
  billingEntityId: 'be-0001',
  companyId: 'adc8745b-f6fa-48a7-82f0-cf82ecd8b7t4',
  directDebitSetupUrl: 'https://example.com',
  isDirectDebit: true,
  billingEntitiesInfo: {
    enrolledCurrencies: 'GBP',
    formFlag: true,
    isDirectDebit: true,
    isMultiBillingEntity: false,
  },
};

export const generateBillingEntity = (
  override: Partial<BillingEntityAPI> = {},
) => ({
  ...DEFAULT_BILLING_ENTITY,
  ...override,
});

export const DEFAULT_BILLING_ENTITIES = [DEFAULT_BILLING_ENTITY];
